import { styled, lighten } from "@mui/material/styles";
import { Button, DialogContent, DialogContentText, Divider } from "@mui/material";

export const Content = styled(DialogContent)(({ theme }) => ({
  borderTop: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderBottom: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
}));

export const ContentText = styled(DialogContentText)({
  padding: "20px 0 0",
});

export const ActionButton = styled(Button)({
  minWidth: "50px",
});

export const TabButton = styled(Button)({
  fontSize: "0.75rem",
  padding: "0px 16px",
  position: "relative",
});
export const VerticalLine = styled(Divider)(({ theme }) => ({
  position: "absolute",
  bottom: "-8px",
  borderColor: theme.palette.primary.main,
  height: "8px",
  borderWidth: "1.5px",
}));
